import React from "react";
import { CriterionInput } from "../../services/rubricAdminService";
import PerformanceLevelsEditor from "./PerformanceLevelsEditor";

interface Props {
  rubricId: string;
  getToken: () => string | undefined;
  value: CriterionInput;
  onChange: (next: CriterionInput) => void;
}

const CriterionDetail: React.FC<Props> = ({ rubricId, getToken, value, onChange }) => {
  const set = <K extends keyof CriterionInput>(k: K, v: CriterionInput[K]) =>
    onChange({ ...value, [k]: v });
  return (
    <div>
      <div className="text-xs text-slate-400 mb-2 uppercase">{value.kind} criterion</div>
      <input
        className="form-control mb-2"
        placeholder="Name"
        value={value.name}
        onChange={(e) => set("name", e.target.value)}
      />
      <textarea
        className="form-control h-16 mb-2 text-sm"
        placeholder="Description"
        value={value.description}
        onChange={(e) => set("description", e.target.value)}
      />
      <textarea
        className="form-control h-20 mb-2 text-sm"
        placeholder="Grader instructions"
        value={value.instructions}
        onChange={(e) => set("instructions", e.target.value)}
      />
      <label className="form-label">Weight</label>
      <input
        className="form-control w-28"
        type="number"
        step="0.05"
        min="0"
        value={value.weight}
        onChange={(e) => set("weight", Number(e.target.value))}
      />
      <PerformanceLevelsEditor
        kind={value.kind}
        rubricId={rubricId}
        getToken={getToken}
        levels={value.performanceLevels}
        onChange={(performanceLevels) => onChange({ ...value, performanceLevels })}
      />
    </div>
  );
};

export default CriterionDetail;
